<template>
  <div class="person-product">
    <template v-for="(item, index) in productList">
      <div class="person-prod-item" :class="[item.classIndexSelect]" v-if="item.resourceType == 1" :key="index" :data-id="item.resourceInfo.productId" :data-index="item.site_number" :data-name="item.resourceInfo.productFullName" data-type="1">
        <single-and-double-permutation :list="item.resourceInfo" :switchStyle='true' @handleGoodClick="handleClick(item, item.site_number)"/>
      </div>
      <div class="person-prod-item" :class="[item.classIndexSelect]" v-if="item.resourceType == 2 || item.resourceType == 6" :key="index" :data-id="item.resourceInfo.id" :data-index="item.site_number" :data-fkcode="item.resourceInfo.planCode" :data-name="item.resourceInfo.planName" :data-type="item.resourceType">
        <productItem :data="item.resourceInfo" @handleClick="handleClick(item, item.site_number)"/>
      </div>
      <div class="person-prod-item" :class="[item.classIndexSelect]" v-if="item.resourceType == 3" :key="index" :data-id="item.resourceInfo.contentId" :data-index="item.site_number" :data-name="item.resourceInfo.title" data-type="3" :data-userid="item.resourceInfo.user.userId" :data-username="item.resourceInfo.user.nickname" :data-usertype="item.resourceInfo.user.userType" :data-topic="item.resourceInfo.topics.name" :data-topicid="item.resourceInfo.topics.id" :data-ctype="item.resourceInfo.contentType">
        <infoItem :data="item.resourceInfo" @handleClick="handleClick(item, item.site_number)"/>
      </div>
      <div class="person-prod-item" :class="[item.classIndexSelect]" v-if="item.resourceType == 4" :key="index" :data-id="item.resourceInfo.id" :data-index="item.site_number" :data-name="item.resourceInfo.pageName" data-type="4" :data-status="item.resourceInfo.releaseStatus">
        <adItem :data="item.resourceInfo" @handleClick="handleClick(item, item.site_number)"/>
      </div>
    </template>

  </div>
</template>

<script>
import singleAndDoublePermutation from '@/components/singleAndDoublePermutation/index'
import productItem from './productItem.vue'
import infoItem from './infoItem.vue'
import adItem from './adItem.vue'
import { mapGetters } from 'vuex'

const liftUserType = {
  1: 'UGC',
  2: 'PGC',
  3: '智家号'
}

const activityStatus = {
  '0': '未发布',
  '1': '发布',
  '-1': '不存在'
}

export default {
  name: 'waterfull',
  components: {
    singleAndDoublePermutation, // 单品
    productItem, // 场景
    infoItem, // 生活家
    adItem, // 广告位
  },
  props: {
    page: { // 瀑布流放置的页面
      type: String,
      default: ''
    },
    pageIndex: {
      type: Number,
      default: 1,
    },
    lists: {
      type: Array,
      default: () => []
    },
    tabId: {
      type: [String, Number],
      default: 'null'
    },
    tabName: {
      type: String,
      default: 'null'
    },
    subNav: {
      type: [String, Number],
      default: 'null'
    },
    subName: {
      type: String,
      default: 'null'
    },
  },
  computed: {
    ...mapGetters({
      location: 'getlocationInfo',
    }),
  },
  data() {
    return {
      productList: this.lists || [],
      intersectionObserver: null,
    }
  },
  beforeDestroy() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect()
    }
  },
  watch: {
    lists: {
      handler(newVal) {
        this.productList = newVal
        this.switchArr()
        this.$nextTick(() => {
          console.log('pageIndex===>', this.pageIndex)
          this.createIntersectionObserver()
        })
      },
      immediate: true
    }
  },
  methods: {
    // type: 物料类型
    clickEventId(type) {
      // 首页不同物料类型对应的事件id
      const homeEventId = {
        1: 'WBSC20009',
        // 2: 'WBSC20011',
        2: 'MPZJ30891',
        3: 'WBSC20013',
        4: 'WBSC20022',
      }
      // 详情页不同物料类型对应的事件id
      const detailEventId = {
        1: 'WBSC20015',
        2: '',
        3: '',
        4: '',
      }
      switch (this.page) {
        case 'home': // 首页
          return homeEventId[type]
        case 'detail': // 详情页
          return detailEventId[type]
      }
    },
    showEventId(type) {
      // 首页不同物料类型对应的事件id
      const homeEventId = {
        1: 'WBSC20008',
        // 2: 'WBSC20010',
        2: 'MPZJ30890',
        3: 'WBSC20012',
        4: 'WBSC20021',
      }
      // 详情页不同物料类型对应的事件id
      const detailEventId = {
        1: 'WBSC20014',
        2: '',
        3: '',
        4: '',
      }
      switch (this.page) {
        case 'home': // 首页
          return homeEventId[type]
        case 'detail': // 详情页
          return detailEventId[type]
      }
    },
    handleClick(item, index) {
      if (!item.resourceInfo) return
      switch (+item.resourceType) {
        case 1:
          let gioParams = {
            product_id: item.resourceInfo.productId,
            product_name: item.resourceInfo.productFullName,
            site_number: index,
            province: this.location.province,
            city: this.location.city,
            county: this.location.district,
            street: this.location.township,
          }
          if (this.page === 'home') {
            gioParams = {
              roughly_classification_id: this.tabId,
              roughly_classification_name: this.tabName,
              ...gioParams,
            }
          }
          this.$util.gioTrackWithVariable(this.clickEventId(1), gioParams)
          break;
        case 2:
        case 6:
          this.$util.gioTrackWithVariable(this.clickEventId(2), {
            // roughly_classification_id: this.tabId,
            roughly_classification_name: +item.resourceType === 2 ? '普通场景' : '本地定制', //this.tabName,
            fk_code: item.resourceInfo.planCode,
            // scene_name: item.resourceInfo.planName,
            // site_number: index,
            // province: this.location.province,
            // city: this.location.city,
            // county: this.location.district,
            // street: this.location.township,
          }).then(() => {
            location.href = +item.resourceType === 2 ? item.resourceInfo.sceneDetailUrl : item.resourceInfo.detailUrl
          })
          break;
        case 3:
          this.$util.gioTrackWithVariable(this.clickEventId(3), {
            roughly_classification_id: this.tabId,
            roughly_classification_name: this.tabName,
            detailed_classification_id: this.subNav,
            detailed_classification_name: this.subName,
            content_id: item.resourceInfo.contentId,
            content_title: item.resourceInfo.title,
            account_id: item.resourceInfo.user.userId,
            account_name: item.resourceInfo.user.nickname,
            content_type: item.resourceInfo.contentType,
            contentTopic: item.resourceInfo.topics.name,
            topicId: item.resourceInfo.topics.id,
            account_type: liftUserType[item.resourceInfo.user.userType],
            site_number: index,
          // province: this.location.province,
          // city: this.location.city,
          // county: this.location.district,
          // street: this.location.township,
          }).then(() => {
            this.contentGoPage(item.resourceInfo)
          })
          break;
        case 4:
          this.$util.gioTrackWithVariable(this.clickEventId(4), {
            roughly_classification_id: this.tabId,
            roughly_classification_name: this.tabName,
            detailed_classification_id: this.subNav,
            detailed_classification_name: this.subName,
            activity_id: item.resourceInfo.id,
            activity_name: item.resourceInfo.pageName,
            activity_status: activityStatus[item.resourceInfo.releaseStatus],
            site_number: index,
          }).then(() => {
            location.href = item.resourceInfo.pageUrl
          })
          break;
      }
    },
    switchArr() {
      this.productList = [].concat(...(Array.from(this.productList.reduce((total, cur, index) => {
        cur.site_number = index + 1
        total[index % 2].push(cur)
        return total
      }, { 0: [], 1: [], length: 2 }))))
    },
    contentGoPage(info) {
      // console.log(process.env.NODE_ENV)
      let url = 'https://zjrs.haier.net/zjapp/ugc/index.html'
      switch (info.contentType) {
        case 'article':
          url += `?contentId=${info.contentId}#/textdetail`
          break;
        case 'picture':
          url += `?contentId=${info.contentId}#/imgdetail`
          break;
        case 'video':
          url += `?contentId=${info.contentId}#/videodetail`
          break;
        case 'installGuide':
          url += `?contentId=${info.contentId}#/installvideodetail`
          break;
        case 'malfunction':
          url += `?contentId=${info.contentId}#/commonfaultdetail`
          break;
        case 'live':
          url = 'https://liveh5.haiersmarthomes.com/live_watch/' + info.liveId
          break;
      }
      location.href = url
    },
    createIntersectionObserver () {
      const options = {
        root: document.querySelector('#app'),
        rootMargin: '50px 0px',
        threshold: 0.8
      }
      // if (this.intersectionObserver) {
      //   this.intersectionObserver.disconnect()
      // }
      this.intersectionObserver = new IntersectionObserver((entries) => {
        for (const ent of entries) {
          if (ent.isIntersecting && ent.intersectionRatio > 0.8 && !+ent.target.getAttribute('data-export')) {
            ent.target.setAttribute('data-export', 1)
            this.gioTrackWithVariable(ent.target, () => {
              this.$util.setTimeOutFn(() => {
                ent.target.setAttribute('data-export', 0)
              })
              // ent.target.setAttribute('data-export', 0)
            })
          }
          // console.log(ent.target.getAttribute('data-export'), ent.target.dataset.index, ent.intersectionRatio)
        }
      }, options)
      for (const dom of document.querySelectorAll('.person-prod-item')) {
        this.intersectionObserver.observe(dom)
      }
    },
    gioTrackWithVariable(target, cb) {
      let { type, id, name, index, username, fkcode, userid, usertype, topicid, topic, ctype, status } = target.dataset
      switch (+type) {
        case 1:
          let gioParams = {
            product_id: id,
            product_name: name,
            site_number: index,
            province: this.location.province,
            city: this.location.city,
            county: this.location.district,
            street: this.location.township,
          }
          if (this.page === 'home') {
            gioParams = {
              roughly_classification_id: this.tabId,
              roughly_classification_name: this.tabName,
              ...gioParams
            }
          }
          this.$util.gioTrackWithVariable(this.showEventId(1), gioParams).then(() => cb())
          break;
        case 2:
        case 6:
          this.$util.gioTrackWithVariable(this.showEventId(2), {
            // roughly_classification_id: this.tabId,
            roughly_classification_name: +type === 2 ? '普通场景' : '本地定制',
            fk_code: fkcode,
            // scene_name: name,
            // site_number: index,
            // province: this.location.province,
            // city: this.location.city,
            // county: this.location.district,
            // street: this.location.township,
          }).then(() => cb())
          break;
        case 3:
          this.$util.gioTrackWithVariable(this.showEventId(3), {
            roughly_classification_id: this.tabId,
            roughly_classification_name: this.tabName,
            detailed_classification_id: this.subNav,
            detailed_classification_name: this.subName,
            content_id: id,
            content_title: name,
            account_id: userid,
            account_name: username,
            content_type: ctype,
            contentTopic: topic,
            topicId: topicid,
            account_type: liftUserType[usertype],
            site_number: index,
          // province: this.location.province,
          // city: this.location.city,
          // county: this.location.district,
          // street: this.location.township,
          }).then(() => cb())
          break;
        case 4:
          this.$util.gioTrackWithVariable(this.showEventId(4), {
            roughly_classification_id: this.tabId,
            roughly_classification_name: this.tabName,
            detailed_classification_id: this.subNav,
            detailed_classification_name: this.subName,
            activity_id: id,
            activity_name: name,
            activity_status: activityStatus[status],
            site_number: index,
          }).then(() => cb())
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.person-product{
  column-count: 2;
}
.person-prod-item{
  break-inside: avoid;
  width: 100%;
  margin-bottom: .16rem;
  background: #fff;
  border-radius: .24rem;
  overflow: hidden;
}

:deep(.public-double-row-goods) {
  margin-top: 0;
  width: 100%;
}

:deep(.public-double-row-goods .left img) {
  width: 100%;
}
</style>
